import FormReg from './LoginSignUp/FormReg';

export default function RegBody(){
    return  <div class="row mt-5 pt-5 d-flex justify-content-center align-items-center">
    <div class="col-lg-12 col-xl-11">
        <div class="text-black">
            <div class="card-body px-md-5">
                <div class="row justify-content-center">
                <div class="col-md-10 col-lg-6 col-xl-5 order-2 order-lg-1">
                    <p class="text-center h1 fw-bold mb-5 mx-1 mx-md-4 mt-4">Sign up</p>
                    <FormReg/>
                </div>
                <div class="col-md-10 col-lg-6 col-xl-7 d-flex align-items-center order-1 order-lg-2">
                    <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-registration/draw1.webp"
                    class="img-fluid" alt="Sample image" />
                </div>
                </div>
            </div>
        </div>
    </div>
</div>
}